module.exports = __webpack_public_path__ + "static/media/logo-small.94ff36f3.png";